import React from "react";

import { ApiGldGldsListRequest } from "@nens/brostar/openapi-client";

import { SearchBox } from "@/components/searchbox";

import { gldInformation } from "../types";

type Props = {
  searchField: keyof ApiGldGldsListRequest;
  setSearchField: (searchField: keyof ApiGldGldsListRequest) => void;
  searchString: string;
  setSearchString: (searchString: string) => void;
};

const GldFilters: React.FC<Props> = ({
  searchField,
  setSearchField,
  searchString,
  setSearchString,
}) => {
  return (
    <SearchBox
      searchField={searchField}
      setSearchField={setSearchField}
      searchString={searchString}
      setSearchString={setSearchString}
      searchOptions={gldInformation}
    />
  );
};

export { GldFilters };
